import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=fd45ad50&scoped=true"
import script from "./template1.vue?vue&type=script&lang=js"
export * from "./template1.vue?vue&type=script&lang=js"
import style0 from "./template1.vue?vue&type=style&index=0&id=fd45ad50&prod&scoped=true&lang=scss"
import style1 from "./template1.vue?vue&type=style&index=1&id=fd45ad50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd45ad50",
  null
  
)

export default component.exports